import {useContext} from 'react';

import {ChatBubbleDotCom} from './ChatBubbleDotCom';
import {DotComChatBubbleAnimationContext} from '../useItemsDotCom';
import {TextBody} from './TextBody';
import {useDotComWordStreamer} from './useDotcomWordStreamer';

type Props = {
  body: string;
  background?: 'neutral100' | 'neutral600';
  messageId?: string;
  children?: React.ReactNode;
};

export const TextBubbleDotCom = ({
  body,
  background = 'neutral100',
  messageId,
  children,
}: Props) => {
  const {animatedMessageId, scaleAnimationDisabled, onAnimationFinished} =
    useContext(DotComChatBubbleAnimationContext);
  const animated = messageId === animatedMessageId;

  const wordStreamer = useDotComWordStreamer({
    text: body,
    disabled: !animated,
    onFinished: () => {
      if (animated) {
        onAnimationFinished();
      }
    },
  });

  // Keep the streamer mounted so an empty message still finishes its turn.
  if (body.trim() === '' && !children) {
    return null;
  }

  const getBubbleAnimation = () => {
    if (!animated) {
      return 'disabled';
    }

    return scaleAnimationDisabled ? 'skip-scale' : 'all';
  };

  return (
    <ChatBubbleDotCom background={background} animation={getBubbleAnimation()}>
      {wordStreamer.textChunk ? (
        <TextBody body={wordStreamer.textChunk} background={background} />
      ) : null}
      {children}
    </ChatBubbleDotCom>
  );
};
